/* src/app/admin-dashboard/product/product.component.css */
.header-color {
  background-color: var(--custom-color);
  color: white;
}
/*# sourceMappingURL=product.component.css.map */
